import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer id="footer" className="relative py-12 border-t border-border/30 bg-background">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4 text-center md:text-left">
          
          {/* Left: Copyright & Powered By */}
          <div className="flex flex-col gap-1 w-full md:w-1/3">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} VANT. All rights reserved.
            </p>
          </div>

          {/* Center: Navigation Links */}
          <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-muted-foreground w-full md:w-1/3">
            <Link to="/faq" className="hover:text-primary transition-colors">
              FAQ
            </Link>
            <Link to="/privacy" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
            {/* Direct mailto link replacing the Contact page */}
            {/* <a href="mailto:support@pingafter.app" className="hover:text-primary transition-colors">
              Support
            </a> */}
            <div className="relative inline-flex items-center opacity-50 cursor-not-allowed text-muted-foreground">
              Support
              <span className="absolute -top-3 -right-6 text-[9px] font-bold bg-slate-200 text-slate-800 px-1.5 py-0.5 rounded-full">
                Soon
              </span>
            </div>
          </nav>

          {/* Right: VANT Brand Glow */}
          <div className="w-full md:w-1/3 flex justify-center md:justify-end">
            <a 
              href="https://vanthq.net" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group flex flex-col items-center md:items-end cursor-pointer"
            >
              <span className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground/40 mb-1 group-hover:text-primary/60 transition-colors duration-500">
                A Product By
              </span>
              <span className="font-display text-3xl font-bold tracking-[0.25em]">
                <span className="text-slate-800 transition-all duration-500 group-hover:text-[#82c668] group-hover:drop-shadow-[0_0_15px_rgba(130,198,104,0.6)]">V</span>
                <span className="text-slate-800 transition-all duration-500 group-hover:text-[#f6d24a] group-hover:drop-shadow-[0_0_15px_rgba(246,210,74,0.6)]">A</span>
                <span className="text-slate-800 transition-all duration-500 group-hover:text-[#61a1d7] group-hover:drop-shadow-[0_0_15px_rgba(97,161,215,0.6)]">N</span>
                <span className="text-slate-800 transition-all duration-500 group-hover:text-[#f18931] group-hover:drop-shadow-[0_0_15px_rgba(241,137,49,0.6)]">T</span>
              </span>
            </a>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
